export default __webpack_public_path__ + "static/media/Sree.50d57be5.png";